import { StylesProvider } from '@material-ui/core/styles'
import MapBoxGL from 'mapbox-gl'
import React, { DependencyList, useMemo } from 'react'
import { createRoot } from 'react-dom/client'

import { muiV4GenerateClassName } from 'src/commons/muiV4Styles'

export class ComponentControl {
  map: MapBoxGL.Map | undefined
  container: HTMLElement
  component: React.ReactElement

  constructor(component: React.ReactElement) {
    this.component = component
    this.container = document.createElement('div')
    this.container.className = 'mapboxgl-ctrl'
  }

  onAdd(map: MapBoxGL.Map) {
    this.map = map
    const root = createRoot(this.container)
    // Mapbox owns this node, so it is its own React root and no provider from 'main' reaches it.
    root.render(<StylesProvider generateClassName={muiV4GenerateClassName}>{this.component}</StylesProvider>)
    return this.container
  }
  onRemove() {
    this.container?.parentNode?.removeChild(this.container)
    this.map = undefined
  }
}

function useComponentControl(
  child: React.ReactElement<any, string | React.JSXElementConstructor<any>>,
  deps: DependencyList
) {
  return useMemo(() => new ComponentControl(child), deps)
}

export default useComponentControl
